import React, { Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import PropTypes from 'prop-types';

import CookiesAlert from './components/CookiesAlert';
import ScrollReset from './components/ScrollReset';
import SuspenseLoading from './components/SuspenseLoading';

const CnhPop = React.lazy(() =>import(
  /* webpackChunkName: "CnhPop" */
  'containers/CnhPop'
))

const containers = {
  cnhpop: CnhPop
};

export default function Routes({ program }) {
  return (<BrowserRouter>
    <ScrollReset />
    <CookiesAlert program={program} />
    <Suspense fallback={<SuspenseLoading />}>
      <Switch>
        <Route path="/" component={containers[program]} />
      </Switch>
    </Suspense>
  </BrowserRouter>);
}

Routes.defaultProps = {
  program: 'cnhpop',
};

Routes.propTypes = {
  program: PropTypes.string,
};
